<template>
  <div>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.gnrl') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.gnrt_bnk_trnsfr_ordr') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxPain001" @change="switchPain001" :disabled="canSwichPain001()" :checked="settings.pain001 === '1'" v-bind:value="settings.pain001">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label labelCheckbox">{{ $t('settings.gnrt_instnt_pymnt') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox"  class="checkboxPacs008 " @change="changeSwitchPacs008" :disabled="canSwitchPacs008()" :checked="settings.pacs008 === '1'" v-bind:value="settings.pacs008">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('directPayments.dir_pymnt_decision_form') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxDecisionCreancier" @change="changeSwitchDecisionCreancier" :disabled="canSwitchCreditorDecision()" :checked="settings.decision_creancier === '1'" v-bind:value="settings.decision_creancier">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
            <label class="label-switch" :class="sliderColorClass">
              <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" :disabled="canSwitchOcrActivation()" :checked="settings.ocrActivation === '1'" v-bind:value="settings.ocrActivation">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.ntfy_rcvr_by_eml') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxEmailRcv" @change="switchEmailRcv" :disabled="canSwitchEmailRcv()" :checked="settings.emailForRcv === '1'" v-bind:value="settings.emailForRcv">
              <div class="checkbox"></div>
            </label>
          </div>
        </div>
      </div>
    </ul>

    <hr>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.othr') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.allwys_accpt_dir_pymnts') }}</label>
            <label class="label-switch " :class="sliderColorClass">
              <input type="checkbox" class="checkboxAutoAcceptPayment" @change="changeSwitchAutoAcceptPayment" :disabled="canSwitchAutoAcceptPayment()" :checked="settings.auto_accept_payment === '1'" v-bind:value="settings.auto_accept_payment">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.hghst_amnt') }}</label>
            <div class="" style="text-align: right;">{{ settings.max_amount }}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="150000" value="0" step="500" :disabled="canSwitchMaxAmount()" v-model="settings.max_amount">
          </div>
        </div>
      </div>
    </ul>

  </div>
</template>

<script>
export default {
  props: ['settings'],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id)
    }
  },
  created () {
  },
  mounted () {
    // expand all menus
    let that = this
    this.Dom7('.accordion-item').addClass('accordion-item-expanded').forEach(item => {
      that.Dom7(item).addClass('accordion-item-expanded')
    })
    this.Dom7('.createInvoiceBand').forEach(item => {
      that.Dom7(item).find('i').transform('rotate(90deg)')
    })
  },
  computed: {
    sliderColorClass () {
      // let fromIdServiceToSliderClass = {
        // '1': 'RTP-slider',
        // '2': 'DD-slider',
        // '6': 'DP-slider'
      // }
      // return fromIdServiceToSliderClass[this.$engine.user.currentService.id]
      return 'RTP-slider'
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    canSwichPain001 () {
      return this.$engine.rights.rightIs('dp_settings_unit_generate_pain', false)
    },
    switchPain001 (obj) {
      this.settings.pain001 = obj.target.checked ? '1' : '0'
      if (this.settings.pain001 === '1') {
        this.Dom7('.checkboxPacs008').prop('disabled', false)
        this.Dom7('.labelCheckbox').removeClass('disablecolor')
        this.Dom7('.li_pacs008').show()
      } else {
        this.settings.pacs008 = '0'
        this.Dom7('.checkboxPacs008').prop('checked', false)
        this.Dom7('.checkboxPacs008').prop('disabled', true)
        this.Dom7('.labelCheckbox').addClass('disablecolor')
        this.Dom7('.li_pacs008').hide()
      }
    },
    canSwitchPacs008 () {
      return this.$engine.rights.rightIs('dp_settings_unit_generate_pain_inst', false)
    },
    // checkboxPacs008 change event
    changeSwitchPacs008 (obj) {
      this.settings.pacs008 = obj.target.checked ? '1' : '0'
    },
    canSwitchEmailRcv () {
      return this.$engine.rights.rightIs('dp_settings_unit_email_receiver', false)
    },
    // checkboxEmailRcv change event
    switchEmailRcv (obj) {
      this.settings.emailForRcv = obj.target.checked ? '1' : '0'
    },
    canSwitchCreditorDecision () {
      return this.$engine.rights.rightIs('dp_settings_unit_decision_creancier', false)
    },
    // checkboxDecisionCreancier change event
    changeSwitchDecisionCreancier (obj) {
      this.settings.decision_creancier = obj.target.checked ? '1' : '0'
    },
    canSwitchOcrActivation () {
      return this.$engine.rights.rightIs('dp_settings_unit_ocr_activation', false)
    },
    changeSwitchOcrActivation (obj) {
      this.settings.ocrActivation = obj.target.checked ? '1' : '0'
    },
    canSwitchAutoAcceptPayment () {
      return this.$engine.rights.rightIs('dp_settings_unit_auto_accept', false)
    },
    // checkboxAutoAcceptPayment change event
    changeSwitchAutoAcceptPayment (obj) {
      this.settings.auto_accept_payment = obj.target.checked ? '1' : '0'
    },
    canSwitchMaxAmount () {
      return this.$engine.rights.rightIs('dp_settings_unit_validation_threshold', false)
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}
</style>



// WEBPACK FOOTER //
// DirectPaymentSettings.vue?59f6a55f